<template>
  <!--
    Вызывается при изменении значения.

    @event input
    @property {String} value Строка поиска.
  -->
  <c-input
    title="ПОИСК ЗАПРОСА:"
    placeholder="введите запрос"
    form-group
    form-group-margin-bottom
    input-group
    :value="value"
    @input="$emit('input', $event)"
  >
    <template v-slot:addonRight>
      <i class="fa fa-search" />
    </template>
  </c-input>
</template>

<script>
import CInput from '../../../../../../resources/js/components/ui/CInput'

/**
 * Текстовое поле для ввода фильтра по запросам.
 */
export default {
  name: 'QuerySearch',
  components: {
    CInput
  },
  props: {
    /**
     * Значение фильтра.
     *
     * @model
     */
    value: {
      type: String,
      required: true
    }
  }
}
</script>
